<div class="image-card">
  <h3>UPDATE PROFILE IMAGE</h3>
  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
  <div class="image-container">

    <img *ngIf="imageUrl" [src]="userImg" alt="Profile Image" class="profile-image" />
    <div class="default-image" *ngIf="!imageUrl">
      <i class="fas fa-user"></i>
    </div>
  </div>
  <div class="user-name" *ngIf="userFullName">{{ userFullName }}</div>
  <div class="card-actions">
    <button *ngIf="imageUrl" (click)="deleteImage()" class="delete-button">Delete</button>
    <input type="file" (change)="handleFileInput($event)" accept="image/*" />
    <button type="button" mat-button (click)="onCancel()">
      Cancel
    </button>
  </div>
</div>